import { LoadingOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal, notification, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useNotify from '../../../context/Notification/useNotify';

import { getBase64 } from '../../../util/util';
import GlobalService from '../../../services/Global.service';
import ConsentService from '../../../services/Consent.service';

export default function ModalAddApplication({
    editObject,
    setApplicationData,
    handelClose,
    handelOk,
    open,
    getApplicationList,
}) {
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const notify = useNotify();

    const [imageUrl, setImageUrl] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    const [imageId, setImageId] = useState('');
    const [fileTypeError, setFileTypeError] = useState(false);

    useEffect(() => {
        if (editObject) {
            form.setFieldsValue({
                applicationName: editObject.applicationName,
                applicationDescription: editObject.applicationDescription,
            });
            if (editObject?.applicationLogoId) {
                setImageId(editObject?.applicationLogoId);
                // setImageUrl(editObject?.img);'
                getImage(editObject?.applicationLogoId);
            } else {
                setImageId();
                setImageUrl();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editObject]);

    const getImage = async (id) => {
        try {
            const { data } = await GlobalService.getImage(id);
            setImageUrl(`data:image/png;base64,${data.resultData?.imageId}`);
        } catch (error) {}
    };

    const beforeUpload = (file) => {
        const isJpgOrPng =
            file.type === 'image/jpeg' || file.type === 'image/png';

        if (!isJpgOrPng) {
            setImageUrl();
            setImageId();
            setFileTypeError(true);
        } else {
            setFileTypeError(false);
        }

        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
            notification['error']({
                message: t('COOKIE.ImageMustSmaller'),
            });
        }

        if (isJpgOrPng && isLt2M) {
            handleChange(file);
        }

        return false;
        // return isJpgOrPng && isLt2M;
    };

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <SvgIconPlus />}
            <div className="mt-2 text-purple">{t('application.addIcon')}</div>
        </div>
    );

    const handleChange = async (file) => {
        let fileList = new FormData();
        fileList.append('image', file);
        fileList.append('fileName', file.name);
        fileList.append('action', 'image-create-application');
        try {
            const { data } = await GlobalService.uploadImage(fileList);
            if (data?.resultData?.imageId) {
                setLoading(false);
                setImageId(data?.resultData?.imageId);
                getBase64(file, (url) => {
                    setImageUrl(url);
                });
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const addApplication = async (payload) => {
        setLoadingForm(true);
        try {
            const { data } = await ConsentService.addApplication(payload);
            _handelClose();
            console.log(
                data?.errorData?.msg,
                data?.errorData?.msg?.includes('DUPLICATE')
            );
            if (data?.resultMsg === 'SUCCESS') {
                setLoadingForm(false);
                getApplicationList();
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
            } else {
                setLoadingForm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submit data'),
                });
            }
        } catch (error) {
            // _handelClose()
            setLoadingForm(false);
            const data = error?.data;
            if (data?.errorData?.msg?.includes('DUPLICATE')) {
                form.setFields([
                    {
                        name: 'applicationName',
                        errors: [t('The application name is duplicate')],
                    },
                ]);
            } else {
                _handelClose();
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submit data'),
                });
            }
        }
    };

    const editApplication = async (payload) => {
        setLoadingForm(true);
        try {
            const { data } = await ConsentService.editApplication(payload);
            _handelClose();
            if (data?.resultMsg === 'SUCCESS') {
                setLoadingForm(false);
                getApplicationList();
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
            } else {
                setLoadingForm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submit data'),
                });
            }
        } catch (error) {
            // _handelClose()
            setLoadingForm(false);
            const data = error?.data;
            if (data?.errorData?.msg?.includes('EXIST')) {
                form.setFields([
                    {
                        name: 'applicationName',
                        errors: [t('The application name is already exist')],
                    },
                ]);
            } else {
                _handelClose();
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submit data'),
                });
            }
        }
    };

    const onFinish = async (value) => {
        if (editObject) {
            const payload = {
                applicationId: editObject?.applicationId,
                applicationLogoId: imageId,
                applicationName: value?.applicationName,
                applicationDescription: value?.applicationDescription,
            };
            await editApplication(payload);
        } else {
            const payload = {
                applicationLogoId: imageId,
                applicationName: value?.applicationName,
                applicationDescription: value?.applicationDescription,
            };
            await addApplication(payload);
        }
    };

    const _handelClose = () => {
        handelClose();
        setImageUrl();
        setImageId();
        form.resetFields();
        setApplicationData();
    };

    return (
        <>
            <Modal
                width={680}
                className="_modal"
                footer={false}
                open={open}
                onCancel={_handelClose}
                // afterClose={()=>{
                //     setImageUrl()
                //     form.resetFields()
                // }}
            >
                <div className="px-6">
                    <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                        <div className="text-1xl font-medium">
                            {editObject
                                ? t('application.editApplication')
                                : t('application.addApplication')}
                        </div>
                    </div>

                    <Form onFinish={onFinish} form={form} layout="vertical">
                        <Form.Item className="mt-4">
                            <div className="flex justify-center w-full">
                                <Upload
                                    listType="picture-card"
                                    className="avatar-uploader w-max"
                                    showUploadList={false}
                                    beforeUpload={beforeUpload}
                                    onChange={(file) => {
                                        if (file?.event?.percent === 100) {
                                            handleChange(file);
                                        } else {
                                            setLoading(true);
                                        }
                                    }}
                                    // action="https://dev-api.whitefact.co/service-gateway/wfsecure/image"
                                    // headers={{
                                    //     authorization: `Bearer ${accessToken}`,
                                    // }}
                                >
                                    {imageUrl ? (
                                        <div className="rounded-full border-2 border-[#65707A]  hover:border-[#1890FF] flex justify-center items-center avatar">
                                            <img
                                                src={imageUrl}
                                                className="rounded-full object-cover"
                                                alt="avatar"
                                            />
                                        </div>
                                    ) : (
                                        uploadButton
                                    )}
                                </Upload>
                            </div>
                            <div
                                hidden={!fileTypeError}
                                className="flex justify-center w-full text-[#F0536F]"
                            >
                                {t('COOKIE.YouUploadFile')}
                            </div>
                        </Form.Item>
                        <Form.Item
                            label={t('application.applicationName')}
                            name="applicationName"
                            rules={[
                                {
                                    required: true,
                                    message: t('Please input application name'),
                                },
                            ]}
                        >
                            <Input
                                placeholder={t('application.applicationName')}
                                size="large"
                                showCount
                                maxLength={30}
                            />
                        </Form.Item>
                        <Form.Item
                            label={t('application.descriptionOfApplication')}
                            name="applicationDescription"
                            rules={[
                                {
                                    required: true,
                                    message: t(
                                        'Please input your description of application'
                                    ),
                                },
                            ]}
                        >
                            <Input.TextArea
                                placeholder={t(
                                    'application.descriptionOfApplication'
                                )}
                                rows={3}
                                size="large"
                                showCount
                                maxLength={50}
                            />
                        </Form.Item>
                        <div className="flex justify-center items-center space-x-4 mt-12 mb-6">
                            <Button
                                htmlType="reset"
                                type="primary"
                                onClick={_handelClose}
                                size="large"
                                ghost
                            >
                                {t('common.Cancel')}
                            </Button>

                            <Button
                                htmlType="submit"
                                loading={loadingForm}
                                onClick={handelOk}
                                size="large"
                                type="primary"
                            >
                                {t('common.Confirm')}
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal>
        </>
    );
}

const SvgIconPlus = () => (
    <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M28.4999 13.5H16.5001V1.49991C16.5001 0.672089 15.828 0 14.9999 0C14.1721 0 13.5 0.672089 13.5 1.49991V13.5H1.49991C0.672089 13.5 0 14.1721 0 14.9999C0 15.828 0.672089 16.5001 1.49991 16.5001H13.5V28.4999C13.5 29.328 14.1721 30.0001 14.9999 30.0001C15.828 30.0001 16.5001 29.328 16.5001 28.4999V16.5001H28.4999C29.328 16.5001 30.0001 15.828 30.0001 14.9999C30.0001 14.1721 29.328 13.5 28.4999 13.5Z"
            fill="#7B67FB"
        />
    </svg>
);
